export enum FurnitureType {
  Kitchen = 'kitchen',
  Wardrobe = 'wardrobe',
  Closet = 'closet',
  Bathroom = 'bathroom',
  Office = 'office',
  Other = 'other'
}
